/* @flow */
import { Link, useParams } from 'react-router';

import type { InternalLinkProps } from './types';
import { stringify } from "qs";

function InternalLink({
  children,
  className,
  onClick,
  query,
  style,
  title,
  to,
  withProjectPath,
  customDataTestID,
}: InternalLinkProps): React.Element {
  const { program, project } = useParams();

  return (
    <Link
      data-testid={customDataTestID}
      className={className}
      onClick={onClick}
      style={style}
      title={title}
      to={{
        pathname: withProjectPath ? `/${program}/${project}/${to}` : `/${to}`,
        search: stringify(query)
      }}
      >
      {children}
    </Link>
  );
}

export default InternalLink;
